import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import {
  WEEKLY_MEETINGS_LIST,
  MEETING_EDIT,
  MEETING_UPDATE,
  MEETING_CANCEL,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  CHAPTER_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
  MEETING_SCHEDULES_REGISTRY,
  MEETING_SCHEDULES_REGISTRY_STATUS_UPDATE,
  MEETING_FEES_REGISTRY,
  MEETING_FEES_REGISTRY_STATUS_UPDATE,
  ATTENDANCE_QR_CODE_GET,
} from "../../routes/routes";
import { NoDataFound, checkEmptyOrNull, hasRole } from "../../components/Utils";
import { usePermission } from "../../hooks/usePermission";
import { MEETING_UPDATED, MEETING_CANCELLED } from "../../constant/constant";
import { FullPageLoader, ModalLoader } from "../../components/common/Loader"; // Import the loader component
import Select from "react-select";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import Loader from "../../components/common/Loader"; // Import the loader component
import { Image, Modal } from "react-bootstrap";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_red.css";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { ValidationMessage } from "../../components/Utils";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Timepicker } from "timepicker-ui-react";
import "timepicker-ui/main.css";
import { MdCancel } from "react-icons/md";


const WeeklyMeetingsList = () => {
  // ## State Variable Declaration
  const navigate = useNavigate();
  const { hasPermission } = usePermission();
  const [meetings, setMeetings] = useState([]);
  const [refresh, setRefresh] = useState(false); // New state to trigger refresh
  const [errors, setErrors] = useState({});
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [loading, setLoading] = useState(true);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [confirmation, setConfirmation] = useState({});
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [filter, setFilter] = useState([]);
  const [detailData, setDetailData] = useState({});
  const [detailsModal, setDetailModal] = useState(false);
  const [schedulesRegistryModal, setSchedulesRegistryModal] = useState(false);
  const [feesRegistryModal, setFeesRegistryModal] = useState(false);
  const [schedulesRegistryData, setSchedulesRegistryData] = useState({});
  const [feesRegistryData, setFeesRegistryData] = useState([]);
  const [feesRegistryMeta, setFeesRegistryMeta] = useState({
    meeting_date: "",
    meeting_time: "",
  });
  const [feesRegistryLoading, setFeesRegistryLoading] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [cancelMeetingId, setCancelMeetingId] = useState(null);
  const [cancelReason, setCancelReason] = useState("");
  const [viewCancelModal, setViewCancelModal] = useState(false);
  const [viewCancelData, setViewCancelData] = useState({});
  const [meetingWeekRange, setMeetingWeekRange] = useState({ minDate: "today", maxDate: null });
  const [qrUrl, setQrUrl] = useState("");
  const [qrLoading, setQrLoading] = useState(false);
  const [qrDownloading, setQrDownloading] = useState(false);
  const [qrModal, setQrModal] = useState(false);

  // Event handler for dates set
  const handleDatesSet = (dateInfo) => {
    const { start, end } = dateInfo;
    const from_date = moment(start).format("YYYY-MM-DD");
    const to_date = moment(end).format("YYYY-MM-DD");
    setFilter({ ...filter, from_date: from_date, to_date: to_date });
  };

  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);
  const selectStatusRef = useRef(null);

  const meetingStatusOptions = [
    { value: 0, label: "Upcoming" },
    { value: 1, label: "Completed" },
    { value: 2, label: "Cancelled" }
  ];

  const handleStateClear = () => {
    if (selectStateRef.current) selectStateRef.current.clearValue();
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
  };

  const handleRegionClear = () => {
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
  };

  const handleChapterClear = () => {
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
  };

  const fetchMeetingData = async (id) => {
    try {
      setErrors({});
      axios.get(MEETING_EDIT + id).then((res) => {
        if (res.status === 200 && res.data.success) {
          let responseData = res.data.data;
          setDetailModal(true);
          const parsedMeetingDate = moment(responseData?.meeting_date, "DD/MM/YYYY");
          // Compute the week boundaries (Sun–Sat) matching moment().week() used by backend
          const weekStart = parsedMeetingDate.clone().startOf("week"); // Sunday
          const weekEnd = parsedMeetingDate.clone().endOf("week");     // Saturday
          const today = moment().startOf("day");
          setMeetingWeekRange({
            minDate: moment.max(today, weekStart).format("YYYY-MM-DD"),
            maxDate: weekEnd.format("YYYY-MM-DD"),
          });
          setDetailData({
            id: responseData?.id,
            region_name: responseData?.region_name,
            chapter_name: responseData?.chapter_name,
            meeting_status: responseData?.meeting_status,
            cancel_reason: responseData?.cancel_reason || "",
            meeting_date: parsedMeetingDate.format("YYYY-MM-DD"),
            meeting_time: moment(responseData?.meeting_time, "hh:mm a").format(
              "hh:mm A",
            ),
          });
        }
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const auth_user = JSON.parse(localStorage.getItem("user"));
  const isSuperAdmin = auth_user?.user_type === 1 ? 1 : 0;
  const isRegionAdmin = auth_user?.user_type === 2 ? 1 : 0;

  const fetchMeetingSchedulesRegistryData = async (id) => {
    try {
      axios
        .get(MEETING_SCHEDULES_REGISTRY + id + "/list")
        .then((res) => {
          if (res.status === 200 && res.data.success) {
            let responseData = res.data.data;
            setSchedulesRegistryData(responseData);
          }
        })
        .finally(() => {
          setLoading(false); // Set loading to false after data is fetched
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const updateMeeting = (meetingId) => {
    setLoading(true);
    setBtnDisabled(true);
    let requestBody = { ...detailData };

    if (requestBody.meeting_time) {
      requestBody.meeting_time = moment(requestBody.meeting_time, [
        "hh:mm A",
        "h:mm A",
        "HH:mm:ss",
        "HH:mm",
      ]).format("HH:mm:ss");
    }

    axios
      .put(MEETING_UPDATE + meetingId, requestBody)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setDetailModal(false);
          toast.success(MEETING_UPDATED, {
            onClose: () => window.location.reload(),
          });
          navigate("/weekly-meetings");
        }
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        } else {
          toast.error(err.response?.data?.msg || "Something went wrong");
        }
      })
      .finally(() => {
        setRefresh(true);
        setLoading(false);
        setBtnDisabled(false);
      });
  };

  const cancelMeeting = (meetingId) => {
    if (!cancelReason.trim()) {
      setErrors({ cancel_reason: ["Cancel Reason is required"] });
      toast.error("Cancel Reason is required");
      return;
    }

    setBtnDisabled(true);
    axios
      .post(MEETING_CANCEL + meetingId, { cancel_reason: cancelReason })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setCancelModal(false);
          setCancelMeetingId(null);
          setCancelReason("");
          setErrors({});
          toast.success(MEETING_CANCELLED);
          setRefresh((prev) => !prev);
        }
      })
      .catch((err) => {
        if (err.response?.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        } else {
          toast.error(err.response?.data?.msg || "Something went wrong");
        }
      })
      .finally(() => {
        setBtnDisabled(false);
      });
  };

  const updateMeetingSchedulesRegistryStatus = async (
    meetingId,
    registryId,
    status,
  ) => {
    axios
      .post(MEETING_SCHEDULES_REGISTRY_STATUS_UPDATE + registryId, {
        status: status,
      })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          toast.success(response.data.msg);
          fetchMeetingSchedulesRegistryData(meetingId);
        }
      })
      .catch((err) => {
        toast.error(err.response.data.msg);
      });
  };

  const fetchMeetingFeesRegistryData = async (id) => {
    setFeesRegistryLoading(true);
    try {
      const res = await axios.get(MEETING_FEES_REGISTRY + id + "/list");
      if (res.status === 200 && res.data.success) {
        setFeesRegistryData(res.data.data?.registrys || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Unable to load meeting fees.");
      setFeesRegistryData([]);
    } finally {
      setFeesRegistryLoading(false);
    }
  };

  const openFeesRegistryModal = (event) => {
    const meetingDate =
      event.extendedProps?.event_date ||
      moment(event.start).format("DD/MM/YYYY");
    const meetingTime =
      event.extendedProps?.event_time ||
      moment(event.start).format("hh:mm A");
    setFeesRegistryMeta({ meeting_date: meetingDate, meeting_time: meetingTime });
    setFeesRegistryModal(true);
    fetchMeetingFeesRegistryData(event.id);
  };

  const updateMeetingFeesRegistryStatus = async (
    meetingId,
    registryId,
    status,
  ) => {
    try {
      const response = await axios.post(
        MEETING_FEES_REGISTRY_STATUS_UPDATE + registryId,
        { status: status },
      );
      if (response.status === 200 && response.data.success) {
        toast.success(response.data.msg);
        fetchMeetingFeesRegistryData(meetingId);
      }
    } catch (err) {
      toast.error(err.response?.data?.msg || "Failed to update payment status.");
    }
  };

  useEffect(() => {
    try {
      axios
        .get(WEEKLY_MEETINGS_LIST, {
          params: {
            isAdmin: 1,
            ...filter,
          },
        })
        .then((response) => {
          if (response.status === 200 && response.data.success) {
            setMeetings(response.data.data.meetings);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }

    const fetchData = async () => {
      try {
        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);

        // Fetch chapter data
        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedChapterOptions = chapterResponse.data.data;
        setChapterOptions(fetchedChapterOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [refresh, filter]);

  useEffect(() => {
    if (!hasPermission("settings-list")) return;

    setQrLoading(true);
    axios
      .get(ATTENDANCE_QR_CODE_GET)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setQrUrl(res.data.data?.url || "");
        }
      })
      .catch(() => {
        setQrUrl("");
      })
      .finally(() => setQrLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleQrDownload = async () => {
    if (!qrUrl) return;

    try {
      setQrDownloading(true);
      const response = await fetch(qrUrl);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = "Attendance-QR-Code.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(objectUrl);
    } catch {
      toast.error("Failed to download QR Code. Please try again.");
    } finally {
      setQrDownloading(false);
    }
  };

  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h5 className="page-title">Meeting Schedules</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">
                    Meeting Schedules List
                  </span>
                </li>
              </ol>
            </div>
            {hasPermission("settings-list") && (
              <div className="col-lg-4 d-flex justify-content-end align-items-center">
                <div className="attendance-qr-strip attendance-qr-strip--header">
                  <div
                    className="attendance-qr-strip__code"
                    onClick={() => qrUrl && setQrModal(true)}
                    style={{ cursor: qrUrl ? "pointer" : "default" }}
                    title={qrUrl ? "Click to view QR Code" : ""}
                  >
                    {qrLoading ? (
                      <div className="attendance-qr-strip__loader">
                        <span className="spinner-border spinner-border-sm text-primary"></span>
                      </div>
                    ) : qrUrl ? (
                      <Image
                        width={48}
                        height={48}
                        src={qrUrl}
                        alt="Attendance QR Code"
                      />
                    ) : (
                      <div className="attendance-qr-strip__empty">
                        <i className="bx bx-error-circle"></i>
                      </div>
                    )}
                  </div>

                  <div
                    className="attendance-qr-strip__info"
                    onClick={() => qrUrl && setQrModal(true)}
                    style={{ cursor: qrUrl ? "pointer" : "default" }}
                  >
                    <h6 className="attendance-qr-strip__title">
                      Attendance QR Code
                    </h6>
                  </div>

                  {qrUrl && (
                    <button
                      type="button"
                      className="attendance-qr-strip__download ms-1"
                      title="Download QR Code"
                      disabled={qrDownloading}
                      onClick={handleQrDownload}
                    >
                      <i
                        className={`bx ${qrDownloading ? "bx-loader-alt bx-spin" : "bx-download"}`}
                      ></i>
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="card icard">
          <div className="container-fluid f_containter">
            <div className="row mb-2">
              {hasRole([1]) && (
                <div className="mb-3 col-md-3">
                  <label className="form-label" htmlFor="country_id">
                    Country
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="country_id"
                    isClearable
                    options={countryOptions}
                    onChange={(selected) => {
                      handleStateClear();
                      setFilter({
                        ...filter,
                        country_id: selected?.value,
                        state_id: null,
                        region_id: null,
                        chapter_id: null,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6]) && (
                <div className="mb-3 col-md-3">
                  <label className="form-label" htmlFor="state_id">
                    State
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    ref={selectStateRef}
                    name="state_id"
                    isClearable
                    options={stateOptions}
                    onChange={(selected) => {
                      handleRegionClear();
                      setFilter({
                        ...filter,
                        state_id: selected?.value,
                        region_id: null,
                        chapter_id: null,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6, 7]) && (
                <div className="mb-3 col-md-3">
                  <label className="form-label" htmlFor="region_id">
                    Region
                  </label>
                  <Select
                    ref={selectRegionRef}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="region_id"
                    isClearable
                    options={regionOptions}
                    onChange={(selected) => {
                      handleChapterClear();
                      setFilter({
                        ...filter,
                        region_id: selected?.value,
                        chapter_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6, 7, 2]) && (
                <div className="mb-3 col-md-3">
                  <label className="form-label" htmlFor="chapter_id">
                    Chapter
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    ref={selectChapterRef}
                    name="chapter_id"
                    isClearable
                    options={chapterOptions}
                    onChange={(selected) =>
                      setFilter({ ...filter, chapter_id: selected?.value })
                    }
                  />
                </div>
              )}

              <div className="mb-3 col-md-3">
                <label className="form-label" htmlFor="meeting_status">
                  Meeting Status
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  ref={selectStatusRef}
                  name="meeting_status"
                  isClearable
                  options={meetingStatusOptions}
                  onChange={(selected) =>
                    setFilter({ ...filter, meeting_status: selected?.value !== undefined ? selected?.value : "" })
                  }
                />
              </div>
            </div>
          </div> 
          <div className="table-responsive">
            <FullCalendar
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              headerToolbar={{
                left: "prev,next",
                center: "title",
                right: "dayGridMonth,timeGridWeek,timeGridDay",
              }}
              firstDay="1"
              displayEventTime={false}
              allDaySlot={false}
              defaultView="month"
              initialView="dayGridMonth"
              themeSystem="bootstrap"
              events={meetings}
              editable={false}
              eventDidMount={(info) => {
                info.el.style.backgroundColor = info.event.backgroundColor;
                info.el.style.borderColor = info.event.borderColor;
                info.el.style.color = info.event.textColor;
                if (Number(info.event.extendedProps.meeting_status) === 2) {
                  info.el.style.opacity = "0.45";
                }
              }}
              defaultTimedEventDuration="02:00:00" // Set the default duration to 2 hour
              // eventClick={(event) => {
              //   fetchMeetingData(event.event.id);
              // }}
              eventContent={(eventContent) => {
                const isCancelled = eventContent.event.extendedProps.meeting_status === 2;
                const cancelReasonText = eventContent.event.extendedProps.cancel_reason;
                const hoverTitle = isCancelled && cancelReasonText
                  ? `${eventContent.event.title} (Cancelled: ${cancelReasonText})`
                  : eventContent.event.title;

                return (
                  <div className="fc-event-main-container">
                    <div
                      className="fc-event-title"
                      title={hoverTitle}
                    >
                      {eventContent.event.title}
                    </div>
                    <div className="fc-event-icons">
                      {hasPermission("meeting-schedules-edit") &&
                        eventContent.event.extendedProps.meeting_status === 0 && (
                          <button
                            className="badge bg-label-info1 border-0 pad-4"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="Edit Meeting Date & Time"
                            data-bs-original-title="Edit Meeting Date & Time"
                            onClick={() => {
                              fetchMeetingData(eventContent.event.id);
                            }}
                          >
                            <i className="bx bx-pencil"></i>
                          </button>
                        )}
                      {hasPermission("meeting-schedules-edit") && (
                        <button
                          className="badge bg-label-success1 border-0 pad-4"
                          data-bs-toggle="tooltip"
                          data-bs-offset="0,4"
                          data-bs-placement="top"
                          data-bs-html="true"
                          title="Attendance Registry"
                          data-bs-original-title="Attendance Registry"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSchedulesRegistryModal(true);
                            fetchMeetingSchedulesRegistryData(
                              eventContent.event.id,
                            );
                          }}
                        >
                          <i className="bx bx-user-check"></i>
                        </button>
                      )}
                      {hasPermission("monthly-fees-list") && (
                        <button
                          className="badge bg-label-warning border-0 pad-4"
                          data-bs-toggle="tooltip"
                          data-bs-offset="0,4"
                          data-bs-placement="top"
                          data-bs-html="true"
                          title="Meeting Fees Registry"
                          data-bs-original-title="Meeting Fees Registry"
                          onClick={(e) => {
                            e.stopPropagation();
                            openFeesRegistryModal(eventContent.event);
                          }}
                        >
                          <i className="bx bx-rupee"></i>
                        </button>
                      )}
                      {hasPermission("meeting-schedules-edit") &&
                        eventContent.event.extendedProps.meeting_status === 0 && (
                          <button
                            className="badge bg-label-info1 border-0 pad-4"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="Cancel Meeting"
                            data-bs-original-title="Cancel Meeting"
                            onClick={(e) => {
                              e.stopPropagation();
                              setCancelMeetingId(eventContent.event.id);
                              setCancelReason("");
                              setErrors({});
                              setCancelModal(true);
                            }}
                          >
                            <MdCancel style={{ color: "#000", fontSize: "20px" }} />
                          </button>
                        )}
                      {isCancelled && (
                        <button
                          className="badge border-0 pad-4"
                          style={{
                            backgroundColor: "#ffffff",
                            color: "#ff3e1d",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "4px",
                            padding: "4px",
                            cursor: "pointer"
                          }}
                          data-bs-toggle="tooltip"
                          data-bs-offset="0,4"
                          data-bs-placement="top"
                          data-bs-html="true"
                          title="View Cancel Reason"
                          data-bs-original-title="View Cancel Reason"
                          onClick={(e) => {
                            e.stopPropagation();
                            const meetingDate =
                              eventContent.event.extendedProps?.event_date ||
                              moment(eventContent.event.start).format("DD/MM/YYYY");
                            const meetingTime =
                              eventContent.event.extendedProps?.event_time ||
                              moment(eventContent.event.start).format("hh:mm A");
                            setViewCancelData({
                              title: eventContent.event.title,
                              meeting_date: meetingDate,
                              meeting_time: meetingTime,
                              cancel_reason: cancelReasonText || "No reason provided",
                              cancelled_by_name: eventContent.event.extendedProps?.cancelled_by_name || "",
                              cancelled_at: eventContent.event.extendedProps?.cancelled_at || "",
                            });
                            setViewCancelModal(true);
                          }}
                        >
                          <i className="bx bx-info-circle" style={{ fontSize: "16px", color: "#ff3e1d" }}></i>
                        </button>
                      )}
                    </div>
                  </div>
                );
              }}
              datesSet={handleDatesSet}
            />
          </div>
        </div>
      </div>

      <Modal
        show={confirmationModal}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setConfirmationModal(false)}
        backdrop="static"
        className="confirmation-modal"
        backdropClassName="confirmation-backdrop"
      >
        <Modal.Header closeButton className="no-border"></Modal.Header>
        <Modal.Body className="idel_popup">
          <div className="icon_holder">
            <div className="pop_del_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#1A4331"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </div>
          </div>
          <h6 className="text-center modal_title">{confirmation?.message}</h6>
          <div className="text-center">
            <button
              onClick={() => {
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-danger btn-sm me-2 iclose_btn"
            >
              No
            </button>
            <button
              onClick={() => {
                confirmation.fn();
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-success btn-sm isubmit_button"
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={detailsModal}
        size="l"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {
          setDetailModal(false);
          setErrors({});
        }}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal_title1"
          >
            Meeting Details ({detailData?.region_name} -{" "}
            {detailData?.chapter_name})
            <span className="datetime-section">
              {detailData?.meeting_date} {detailData?.meeting_time}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ position: "relative" }}>
          <ModalLoader visible={btnDisabled} />
          <div className="card-body py-0">
            <div className="row">
              {/* <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="meeting_region">
                    Region<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    readonly="true"
                    disabled="true"
                    className="form-control hide-arrow"
                    defaultValue={detailData?.region_name}
                    style={{ background: "#eee", cursor: "not-allowed" }}
                  />
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="meeting_chapter">
                    Chapter<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    readonly="true"
                    disabled="true"
                    className="form-control hide-arrow"
                    defaultValue={detailData?.chapter_name}
                    style={{ background: "#eee", cursor: "not-allowed" }}
                  />
                </div>
              </div> */}

              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="meeting_date">
                    Meeting Date<span className="text-danger">*</span>
                  </label>
                  <Flatpickr
                    className="form-control"
                    options={{
                      dateFormat: "Y-m-d",
                      enableTime: false,
                      minDate: meetingWeekRange.minDate,
                      maxDate: meetingWeekRange.maxDate,
                      onChange: (selected) =>
                        setDetailData({
                          ...detailData,
                          meeting_date: moment(selected[0]).format(
                            "YYYY-MM-DD",
                          ),
                        }),
                    }}
                    value={detailData?.meeting_date}
                    placeholder="Select Event Date"
                  />
                  <ValidationMessage error={errors} name="meeting_date" />
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="meeting_time">
                    Meeting Time<span className="text-danger">*</span>
                  </label>
                  <Timepicker
                    id="meeting_time"
                    className="form-control"
                    placeholder="Select From Time"
                    options={{
                      clock: { type: "12h" },
                      ui: { clearButton: true },
                    }}
                    defaultValue={detailData?.meeting_time}
                    onConfirm={(data) => {
                      const hour = data?.hour;
                      const minutes = data?.minutes;
                      const type = data?.type;
                      let timeStr = `${hour}:${minutes} ${type}`;
                      const formatted = moment(timeStr, [
                        "h:mm A",
                        "HH:mm",
                      ]).format("HH:mm:ss");
                      setDetailData({
                        ...detailData,
                        meeting_time: formatted,
                      });
                    }}
                    onClear={() => {
                      setDetailData({ ...detailData, meeting_time: "" });
                    }}
                  />
                  <ValidationMessage error={errors} name="from_time" />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-success isubmit_button"
            data-bs-dismiss="modal"
            onClick={() => updateMeeting(detailData?.id)}
          >
            Update
          </button>
          <button
            type="button"
            className="btn btn-secondary ibutton"
            data-bs-dismiss="modal"
            onClick={() => {
              setDetailModal(false);
              setErrors({});
            }}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={schedulesRegistryModal}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setSchedulesRegistryModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal_title1"
          >
            Meeting Attendance Details
            <span className="datetime-section">
              {schedulesRegistryData?.meeting_date}{" "}
              {schedulesRegistryData?.meeting_time}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive text-nowrap">
            <table className="table table-striped itable">
              <thead>
                <tr>
                  <th style={{ textAlign: "center", width: "10%" }}>Sl. No.</th>
                  <th style={{ textAlign: "center", width: "60%" }}>Member Name</th>
                  <th style={{ textAlign: "center", width: "30%" }}>
                    Attended Status
                  </th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan="3" />
                ) : schedulesRegistryData?.registrys?.length > 0 ? (
                  schedulesRegistryData?.registrys?.map((registry, i) => (
                    <tr key={i}>
                      <td>{registry?.sno}</td>
                      <td>
                        <span className="table_img pr-2">
                          <img src={registry?.user_profile_image} alt="icon" />
                        </span>
                        {registry?.user_name}
                      </td>
                      <td>
                        <Form.Check
                          type="switch"
                          id={`custom-switch-${i}`}
                          value="1"
                          checked={
                            registry?.meeting_status === 1 ? true : false
                          }
                          disabled={schedulesRegistryData?.meeting_status === 2}
                          label=""
                          onChange={(event) => {
                            if (schedulesRegistryData?.meeting_status === 2) {
                              return;
                            }
                            const statusVal = event.target.checked ? 1 : 2;
                            updateMeetingSchedulesRegistryStatus(
                              registry?.meeting_id,
                              registry?.id,
                              statusVal,
                            );
                          }}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoDataFound colspan="3" message="No Data Found" />
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary ibutton"
            data-bs-dismiss="modal"
            onClick={() => setSchedulesRegistryModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={cancelModal}
        size="md"
        aria-labelledby="cancel-meeting-modal-title"
        centered
        onHide={() => {
          setCancelModal(false);
          setCancelMeetingId(null);
          setCancelReason("");
          setErrors({});
        }}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="cancel-meeting-modal-title" className="modal_title1">
            Cancel Meeting
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ position: "relative" }}>
          <ModalLoader visible={btnDisabled} />
          <div className="mb-3">
            <label className="form-label" htmlFor="cancel_reason">
              Cancel Reason<span className="text-danger">*</span>
            </label>
            <textarea
              id="cancel_reason"
              className="form-control"
              rows="4"
              placeholder="Enter cancel reason"
              value={cancelReason}
              onChange={(e) => {
                setCancelReason(e.target.value);
                if (errors.cancel_reason) {
                  setErrors((prev) => {
                    const next = { ...prev };
                    delete next.cancel_reason;
                    return next;
                  });
                }
              }}
            />
            <ValidationMessage error={errors} name="cancel_reason" />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-danger isubmit_button"
            disabled={btnDisabled}
            onClick={() => cancelMeeting(cancelMeetingId)}
          >
            Cancel Meeting
          </button>
          <button
            type="button"
            className="btn btn-secondary ibutton"
            onClick={() => {
              setCancelModal(false);
              setCancelMeetingId(null);
              setCancelReason("");
              setErrors({});
            }}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={viewCancelModal}
        size="md"
        aria-labelledby="view-cancel-meeting-modal-title"
        centered
        onHide={() => {
          setViewCancelModal(false);
          setViewCancelData({});
        }}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="view-cancel-meeting-modal-title" className="modal_title1">
            Cancelled Meeting Details
            <span className="datetime-section">
              {viewCancelData?.meeting_date} {viewCancelData?.meeting_time}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ whiteSpace: "normal" }}>
          <div className="mb-3">
            <label className="form-label fw-bold mb-1">Meeting</label>
            <div className="text-secondary">{viewCancelData?.title}</div>
          </div>
          <div className="mb-3">
            <label className="form-label fw-bold text-danger mb-1">Cancel Reason</label>
            <div
              style={{
                color: "#333333",
                width: "100%",
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflowWrap: "anywhere",
                lineHeight: "1.6",
                fontSize: "14px",
                display: "block"
              }}
            >
              {viewCancelData?.cancel_reason || "No reason provided"}
            </div>
          </div>
          {viewCancelData?.cancelled_by_name && (
            <div className="mb-3">
              <label className="form-label fw-bold mb-1">Cancelled By</label>
              <div className="text-secondary">{viewCancelData?.cancelled_by_name}</div>
            </div>
          )}
          {viewCancelData?.cancelled_at && (
            <div className="mb-3">
              <label className="form-label fw-bold mb-1">Cancelled At</label>
              <div className="text-secondary">{viewCancelData?.cancelled_at}</div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary ibutton"
            onClick={() => {
              setViewCancelModal(false);
              setViewCancelData({});
            }}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={feesRegistryModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setFeesRegistryModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal_title1"
          >
            Meeting Fees Details
            <span className="datetime-section">
              {feesRegistryMeta?.meeting_date} {feesRegistryMeta?.meeting_time}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive text-nowrap">
            <table className="table table-striped itable">
              <thead>
                <tr>
                  <th style={{ textAlign: "center", width: "10%" }}>Sl. No.</th>
                  <th style={{ textAlign: "center", width: "45%" }}>Member Name</th>
                  <th style={{ textAlign: "center", width: "20%" }}>
                    Fee Amount
                  </th>
                  <th style={{ textAlign: "center", width: "25%" }}>
                    Payment Status
                  </th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {feesRegistryLoading ? (
                  <Loader loading={feesRegistryLoading} colspan="4" />
                ) : feesRegistryData.length > 0 ? (
                  feesRegistryData.map((registry, i) => (
                    <tr key={i}>
                      <td>{registry?.sno}</td>
                      <td>
                        <span className="table_img pr-2">
                          <img src={registry?.user_profile_image} alt="icon" />
                        </span>
                        {registry?.user_name}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {registry?.fee_amount}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <Form.Check
                          type="switch"
                          id={`fees-switch-${i}`}
                          value="1"
                          disabled={!hasPermission("monthly-fees-edit")}
                          checked={
                            registry?.payment_status === 1 ? true : false
                          }
                          label=""
                          onChange={(event) => {
                            const statusVal = event.target.checked ? 1 : 0;
                            setConfirmationModal(true);
                            setConfirmation({
                              message:
                                "Are you sure you want to update the payment status?",
                              fn: () =>
                                updateMeetingFeesRegistryStatus(
                                  registry?.meeting_id,
                                  registry?.id,
                                  statusVal,
                                ),
                            });
                          }}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoDataFound colspan="4" message="No Data Found" />
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary ibutton"
            data-bs-dismiss="modal"
            onClick={() => setFeesRegistryModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      {/* QR Code Popup Modal */}
      <Modal
        show={qrModal}
        size="sm"
        aria-labelledby="attendance-qr-modal-title"
        centered
        onHide={() => setQrModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="attendance-qr-modal-title" className="modal_title1">
            Attendance QR Code
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          {qrUrl ? (
            <>
              <div
                style={{
                  display: "inline-block",
                  padding: "16px",
                  background: "#fff",
                  borderRadius: "12px",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
                  marginBottom: "16px",
                }}
              >
                <Image
                  src={qrUrl}
                  alt="Attendance QR Code"
                  style={{ width: "220px", height: "220px", display: "block" }}
                />
              </div>
              <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                Scan this QR code to mark your attendance
              </p>
            </>
          ) : (
            <p className="text-muted">QR Code not available</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-success isubmit_button"
            disabled={qrDownloading || !qrUrl}
            onClick={handleQrDownload}
          >
            <i className={`bx ${qrDownloading ? "bx-loader-alt bx-spin" : "bx-download"} me-1`}></i>
            {qrDownloading ? "Downloading..." : "Download QR"}
          </button>
          <button
            type="button"
            className="btn btn-secondary ibutton"
            onClick={() => setQrModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default WeeklyMeetingsList;
